import React from 'react';
import {Text, View} from 'react-native';
import styles from './TitleValue.style';

export default function TitleValue(props) {
  const {title, value, valueStyle, containerStyle} = props;

  return (
    <View style={[styles.container, containerStyle]}>
      <Text style={[styles.value, valueStyle]}>{value}</Text>
      <Text style={styles.title}>{title}</Text>
    </View>
  );
}
